import { Component, OnInit,Input, Output, EventEmitter, HostListener } from '@angular/core';
export interface HotelImage {
  imageUrl: string;
  caption: string;
}
@Component({
  selector: 'app-hotel-gallery',
  templateUrl: './hotel-gallery.component.html',
  styleUrls: ['./hotel-gallery.component.css']
})
export class HotelGalleryComponent {
  @Input() hotelName: string = '';
  @Input() hotelType: string = '';
  @Input() images: HotelImage[] = [];
  @Output() close = new EventEmitter<void>();

  // Lightbox state
  lightboxOpen = false;
  currentImageIndex = 0;
  currentImage: HotelImage | null = null;

  get totalImages(): number {
    return this.images.length;
  }

  // Open lightbox with specific image
  openLightbox(index: number): void {
    if (index >= 0 && index < this.images.length) {
      this.currentImageIndex = index;
      this.currentImage = this.images[index];
      this.lightboxOpen = true;
      document.body.style.overflow = 'hidden';
    }
  }

  // Close lightbox
  closeLightbox(): void {
    this.lightboxOpen = false;
    this.currentImage = null;
    document.body.style.overflow = '';
  }

  // Navigate to next image
  nextImage(): void {
    if (this.currentImageIndex < this.images.length - 1) {
      this.currentImageIndex++;
      this.currentImage = this.images[this.currentImageIndex];
    }
  }

  // Navigate to previous image
  prevImage(): void {
    if (this.currentImageIndex > 0) {
      this.currentImageIndex--;
      this.currentImage = this.images[this.currentImageIndex];
    }
  }

  // Close entire gallery modal
  closeGallery(): void {
    this.closeLightbox();
    this.close.emit();
  }

  // Keyboard navigation
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (this.lightboxOpen) {
      switch (event.key) {
        case 'ArrowRight':
          this.nextImage();
          break;
        case 'ArrowLeft':
          this.prevImage();
          break;
        case 'Escape':
          this.closeLightbox();
          break;
      }
    }
  }

  // Handle backdrop click
  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('lightbox-overlay')) {
      this.closeLightbox();
    }
  }
}
